import React from "react";
import { Package, Book, AlertCircle, DollarSign, Wallet } from "lucide-react";

export default function ResumenTab({
  stockActualEnLibrerias,
  totalEjemplaresVendidos,
  totalVentasCortesia,
  dineroPendiente,
  dineroCobrado,
  dineroTotalFacturado,
  inventarioRows,
  ventasOrdenadas,
  libreriasById,
  onCambiarEstadoVenta
}) {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Panel de Control</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center space-x-4"><div className="p-3 bg-blue-100 text-blue-600 rounded-lg"><Package size={24} /></div><div><p className="text-sm text-gray-500">Stock en Librerías</p><p className="text-2xl font-bold text-gray-800">{stockActualEnLibrerias}</p></div></div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center space-x-4">
          <div className="p-3 bg-green-100 text-green-600 rounded-lg"><Book size={24} /></div>
          <div>
            <p className="text-sm text-gray-500">Total Vendidos</p>
            <p className="text-2xl font-bold text-gray-800">{totalEjemplaresVendidos}</p>
            {totalVentasCortesia > 0 && <p className="text-xs text-gray-400">{totalVentasCortesia} de cortesía</p>}
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center space-x-4"><div className="p-3 bg-indigo-100 text-indigo-600 rounded-lg"><Wallet size={24} /></div><div><p className="text-sm text-gray-500">Total Facturado</p><p className="text-2xl font-bold text-gray-800">${dineroTotalFacturado.toFixed(2)}</p></div></div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center space-x-4"><div className="p-3 bg-yellow-100 text-yellow-600 rounded-lg"><AlertCircle size={24} /></div><div><p className="text-sm text-gray-500">Pendiente de Cobro</p><p className="text-2xl font-bold text-gray-800">${dineroPendiente.toFixed(2)}</p></div></div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center space-x-4"><div className="p-3 bg-green-100 text-green-600 rounded-lg"><DollarSign size={24} /></div><div><p className="text-sm text-gray-500">Ingresos Cobrados</p><p className="text-2xl font-bold text-gray-800">${dineroCobrado.toFixed(2)}</p></div></div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-6 border-b border-gray-100 bg-gray-50/50"><h3 className="text-lg font-semibold text-gray-800">Inventario por Librería</h3></div>
          <div className="p-0 overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead><tr className="bg-gray-50 text-gray-500 text-sm border-b"><th className="p-4 font-medium">Librería</th><th className="p-4 font-medium">Libro</th><th className="p-4 font-medium text-center">Stock Actual</th></tr></thead>
              <tbody className="divide-y divide-gray-100">
                {inventarioRows.map((row) => (
                  <tr key={row.key} className="hover:bg-gray-50/50"><td className="p-4 text-sm text-gray-800">{row.libreriaNombre}</td><td className="p-4 text-sm text-gray-600">{row.libroTitulo}</td><td className="p-4 text-sm font-medium text-center text-indigo-600"><span className="bg-indigo-50 px-3 py-1 rounded-full">{row.stock}</span></td></tr>
                ))}
                {inventarioRows.length === 0 && <tr><td colSpan="3" className="p-4 text-center text-gray-500 text-sm">No hay datos de inventario.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-6 border-b border-gray-100 bg-gray-50/50"><h3 className="text-lg font-semibold text-gray-800">Ventas & Facturación</h3></div>
          <div className="p-0 overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead><tr className="bg-gray-50 text-gray-500 text-sm border-b"><th className="p-4 font-medium">Librería</th><th className="p-4 font-medium">Importe</th><th className="p-4 font-medium">Estado</th><th className="p-4 font-medium text-right">Acción</th></tr></thead>
              <tbody className="divide-y divide-gray-100">
                {ventasOrdenadas.map((venta) => {
                  const libreria = libreriasById[venta.libreriaId];
                  return (
                    <tr key={venta.id} className="hover:bg-gray-50/50">
                      <td className="p-4 text-sm text-gray-800">
                        {libreria?.nombre || "Desconocida"}
                        {Boolean(Number(venta.cortesia)) && <span className="ml-2 px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700">Cortesía</span>}
                      </td>
                      <td className="p-4 text-sm font-medium text-gray-800">${Number(venta.importe || 0).toFixed(2)}</td>
                      <td className="p-4 text-sm"><span className={`px-2 py-1 rounded-full text-xs font-medium ${venta.estado === "Pendiente" ? "bg-yellow-100 text-yellow-700" : ""} ${venta.estado === "Facturada" ? "bg-blue-100 text-blue-700" : ""} ${venta.estado === "Cobrada" ? "bg-green-100 text-green-700" : ""}`}>{venta.estado}</span></td>
                      <td className="p-4 text-right space-x-2">
                        {venta.estado === "Pendiente" && <button onClick={() => onCambiarEstadoVenta(venta.id, "Facturada")} className="text-xs bg-blue-50 text-blue-600 hover:bg-blue-100 px-3 py-1 rounded-md transition-colors">Facturar</button>}
                        {venta.estado === "Facturada" && <button onClick={() => onCambiarEstadoVenta(venta.id, "Cobrada")} className="text-xs bg-green-50 text-green-600 hover:bg-green-100 px-3 py-1 rounded-md transition-colors">Cobrar</button>}
                      </td>
                    </tr>
                  );
                })}
                {ventasOrdenadas.length === 0 && <tr><td colSpan="4" className="p-4 text-center text-gray-500 text-sm">No hay ventas registradas.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
